import React from "react";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

//import Scss
import "./assets/scss/themes.scss";

//imoprt Route
import Route from "./Routes";

// components
import ScrollToTop from "./Components/Common/ScrollToTop";

function App() {
  return (
    <React.Fragment>
      <ScrollToTop />
      <Route />
      <ToastContainer />
    </React.Fragment>
  );
}

export default App;
